import React from 'react'
import {
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'

import Facade from '../common/Facade'
import View from '../common/View'
import Access from '../common/Access'
import Usage from '../common/Usage'
import Plan from '../common/Plan'
import LandCondition from '../common/land/LandCondition'
import WithBuilding from '../common/land/WithBuilding'
import WithBuildingSqr from '../common/land/WithBuildingSqr'
import BuildFactor from '../common/land/BuildFactor'
import CoverageFactor from '../common/land/CoverageFactor'
import MaxAllowedHeight from '../common/land/MaxAllowedHeight'
import PlotWidth from '../common/land/PlotWidth'
import PlotLength from '../common/land/PlotHeight'
import SlopeAmphitheater from '../common/land/SlopeAmphitheater'
import Compensation from '../common/land/Compensation'
import DistancePort from '../common/land/DistancePort'
import DistanceRoadNetwork from '../common/land/DistanceRoadNetwork'
// import DistanceVillage from '../common/land/DistanceVillage'
import DistanceAirport from '../common/land/DistanceAirport'
// import DistanceTown from '../common/land/DistanceTown'
// import DistanceSea from '../common/land/DistanceSea'
import WaterSupply from '../common/land/WaterSupply'
import Electrification from '../common/land/Electrification'
import Enclosure from '../common/land/Enclosure'
import Drains from '../common/land/Drains'
import NumberOfViews from '../common/land/NumberOfViews'
import NonForest from '../common/land/NonForest'
import ForestCover from '../common/land/ForestCover'
import ForestCoverSqr from '../common/land/ForestCoverSqr'

import { FormValues } from '..'
interface Props {
  control: Control<FormValues>
  trigger?: UseFormTrigger<FormValues>
  getValues: UseFormGetValues<FormValues>
  resetField: UseFormResetField<FormValues>
  setValue: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}

const LandPlotFields = (props: Props) => {
  const { control, trigger, getValues, resetField, setValue } = props
  return (
    <>
      <Usage
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Plan
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <WithBuilding
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <WithBuildingSqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <BuildFactor
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CoverageFactor
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <MaxAllowedHeight
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Facade
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <PlotWidth
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <PlotLength
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <SlopeAmphitheater
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <View
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Access
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Compensation
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <DistancePort
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <DistanceRoadNetwork
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      {/* <DistanceVillage
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue} trigger={trigger}
      /> */}
      <DistanceAirport
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      {/* 
      <DistanceTown
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <DistanceSea
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      /> */}
      <LandCondition
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <NumberOfViews
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <NonForest
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ForestCover
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ForestCoverSqr
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />

      <WaterSupply
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Electrification
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Enclosure
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Drains
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
    </>
  )
}

export default React.memo(LandPlotFields)
